import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Box, Group, Text, useMantineTheme, Avatar, Divider } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { safeValue, CustomerCategoryIcon, sqlDateToIsoDate } from "../../utils/globalFunctions";
import { canAccessSeeCustomersPhoneNumber, canAccessSeeModulQC, canAccessInvoiceDanBuktiBayar, stepsCanAccessInvoice, stepsCanAccessBuktiBayar, canAccessTandaTerima, stepsCanAccessTandaTerima } from "../../utils/accessing";

import ModalResponse from "../general/ModalResponse";
import PaperWrapper from "./PaperWrapper";
import TanggalMasukProjectDibatalkan from "./TanggalMasukProjectDibatalkan";
import NomorNotaDibatalkan from "./NomorNotaDibatalkan";
import BarangCategoryDibatalkan from "./BarangCategoryDibatalkan";
import BarangNamaDibatalkan from "./BarangNamaDibatalkan";
import BarangKeluhanDibatalkan from "./BarangKeluhanDibatalkan";
import BarangKelengkapanDibatalkan from "./BarangKelengkapanDibatalkan";

import BarangFormCek from "../../components/utilities/BarangFormCek";
import BarangFormCekQC from "../../components/utilities/BarangFormCekQC";
import MediaImageVideoCarousel from "../../components/utilities/MediaImageVideoCarousel";

import BarangFormCekDibatalkan from "./BarangFormCekDibatalkan";
import BarangFormCekQCDibatalkan from "./BarangFormCekQCDibatalkan";

import BarangProjectNotaFotoDibatalkan from "./BarangProjectNotaFotoDibatalkan";
import MediaImageVideoCarouselDibatalkan from "./MediaImageVideoCarouselDibatalkan";
import BarangDPBiayaDibatalkan from "./BarangDPBiayaDibatalkan";
import BarangDPBiayaMetodeDibatalkan from "./BarangDPBiayaMetodeDibatalkan";
import RekomendasiPenerimaDibatalkan from "./RekomendasiPenerimaDibatalkan";
import RekomendasiPenerimaInfoDibatalkan from "./RekomendasiPenerimaInfoDibatalkan";
import ProjectNotaCatatanDibatalkan from "./ProjectNotaCatatanDibatalkan";
import PriorityNotaDibatalkan from "./PriorityNotaDibatalkan";
import JenisService from "../../components/utilities/JenisService";
import DateLinePengecekanDibatalkan from "./DateLinePengecekanDibatalkan";
import DateLineSelesaiDibatalkan from "./DateLineSelesaiDibatalkan";

import INVBBComponent from "../../components/documents/pdf/renderer/INVBBComponent";
import TandaTerimaComponent from "../../components/documents/pdf/renderer/TandaTerimaComponent";

const StepNotaDibatalkan = ({
    stateURI1,
    stateUtilsRef,
    fnClickPhoto,
    stateShowMediaQC,
    fnClickMediaImageVideo
}) => {

    const mountedRef = React.useRef(true);

    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetDataProject: 'projectNotaAdd-1',
        successSubmitData: 'projectNotaAdd-2',
        errorSubmitData: 'projectNotaAdd-3',
    })

    const constProjectNotaCustomer = {
        id: 'addProjectNotaCustomer',
        label: 'Customer',
        withAsterisk: false,
        placeholder: 'Customer',
        value: {
            id: '',
            name: '',
            gender: '1',
            address: '',
            contact: '',
            categorySlug: '',
            categoryName: '',
        },
        description: '',
        error: ''
    }

    const constProjectNotaNomor = {
        id: 'addProjectNotaNomor',
        label: 'Nomor Nota',
        withAsterisk: false,
        placeholder: 'Nomor Nota',
        value: {
            id: '',
            userCreatedName: '',
            userCreatedSubLevel: '',
            createdDateTime: ''
        },
        description: '',
        error: ''
    }

    const constProjectNotaTanggalMasuk = {
        id: 'addProjectNotaTanggalMasuk',
        label: 'Tanggal Masuk',
        withAsterisk: false,
        placeholder: 'Tanggal Masuk',
        value: new Date(),
        description: '',
        error: ''
    }

    const constProjectNotaBarangCategory = {
        id: 'addProjectNotaBarangCategory',
        label: 'Kategori Barang',
        withAsterisk: false,
        placeholder: 'Kategori Barang',
        value: {
            id: ''
        },
        description: '',
        error: ''
    }

    const constProjectNotaBarangNama = {
        id: 'addProjectNotaBarangNama',
        label: 'Nama Barang',
        withAsterisk: false,
        placeholder: 'Nama Barang',
        value: '',
        description: '',
        error: ''
    }

    const constProjectNotaBarangKeluhan = {
        id: 'addProjectNotaBarangKeluhan',
        label: 'Keluhan / Kerusakan',
        withAsterisk: false,
        placeholder: 'Keluhan / Kerusakan',
        value: '',
        description: '',
        error: ''
    }

    const constProjectNotaBarangKelengkapan = {
        id: 'addProjectNotaBarangKelengkapan',
        label: 'Kelengkapan Barang',
        withAsterisk: false,
        placeholder: 'Kelengkapan Barang',
        value: [],
        description: '',
        error: ''
    }

    const constProjectNotaBarangFormCek = {
        id: 'addProjectNotaBarangFormCek',
        label: 'Form Ceklis',
        withAsterisk: false,
        placeholder: 'Form Ceklis',
        value: {
            masterId: '',
            detil: []
        },
        description: '',
        error: ''
    }

    const constProjectQCBarangFormCek = {
        id: 'componentProjectQCBarangFormCek',
        label: 'Form Ceklis',
        withAsterisk: false,
        placeholder: 'Form Ceklis',
        value: {
            masterId: '',
            detil: []
        },
        description: '',
        error: ''
    }

    const constProjectNotaBarangFoto = {
        id: 'addProjectNotaBarangFoto',
        label: 'Foto Barang',
        withAsterisk: false,
        placeholder: 'Foto Barang',
        value: [],
        description: '',
        error: ''
    }

    const constProjectMediaQC = {
        id: 'addProjectMediaQC',
        label: 'Foto & Video Hasil QC',
        withAsterisk: false,
        placeholder: 'Foto & Video Hasil QC',
        value: [],
        description: '',
        error: ''
    }

    const constProjectNotaDPBiaya = {
        id: 'addProjectNotaDPBiaya',
        label: 'Uang Muka',
        withAsterisk: false,
        placeholder: 'Uang Muka',
        value: '',
        description: '',
        error: ''
    }

    const constProjectNotaDPMetode = {
        id: 'addProjectNotaDPMetode',
        label: 'Metode Bayar',
        withAsterisk: false,
        placeholder: 'Metode Bayar',
        value: '',
        description: '',
        error: ''
    }

    const constProjectNotaRekomendasiPengerjaan = {
        id: 'addProjectNotaRekomendasiPengerjaan',
        label: 'Rekomendasi Pengerjaan',
        withAsterisk: false,
        placeholder: 'Rekomendasi Pengerjaan',
        value: {
            id: '',
            name: '',
            gender: '',
            level: '',
            subLevel: '',
        },
        description: '',
        error: ''
    }

    const constProjectNotaRekomendasiCatatan = {
        id: 'addProjectNotaRekomendasiCatatan',
        label: 'Catatan Rekomendasi',
        withAsterisk: false,
        placeholder: 'Catatan Rekomendasi',
        value: '',
        description: '',
        error: ''
    }

    const constProjectNotaCatatan = {
        id: 'addProjectNotaCatatan',
        label: 'Catatan Nota',
        withAsterisk: false,
        placeholder: 'Catatan Nota',
        value: '',
        description: '',
        error: ''
    }

    const constProjectNotaProjectPriority = {
        id: 'addProjectNotaProjectPriority',
        label: 'Prioritas Project',
        withAsterisk: false,
        placeholder: 'Prioritas Project',
        value: '3',
        description: '',
        error: ''
    }

    const constProjectNotaDateLinePengecekan = {
        id: 'addProjectNotaDateLinePengecekan',
        label: 'Deadline Pengecekan',
        withAsterisk: false,
        placeholder: 'Deadline Pengecekan',
        value: new Date(),

        hasPengecekan: null,
        dateLine: null,
        today: null,

        description: '',
        error: ''
    }

    const constProjectNotaDateLineSelesai = {
        id: 'addProjectNotaDateLineSelesai',
        label: 'Deadline Selesai',
        withAsterisk: false,
        placeholder: 'Deadline Selesai',
        value: new Date(),

        tanggalSelesai: null,
        dateLine: null,
        today: null,

        description: '',
        error: ''
    }

    const [data, setData] = React.useState({
        projectDataInitLoading: false,
        projectDataFlag: 'idle',

        projectCancelFrom: '',

        projectCustomer: constProjectNotaCustomer,
        projectNotaNomor: constProjectNotaNomor,
        projectNotaTanggalMasuk: constProjectNotaTanggalMasuk,

        projectNotaBarangCategory: constProjectNotaBarangCategory,
        projectNotaBarangNama: constProjectNotaBarangNama,
        projectNotaBarangKeluhan: constProjectNotaBarangKeluhan,

        projectNotaBarangKelengkapan: constProjectNotaBarangKelengkapan,

        projectNotaBarangFormCek: constProjectNotaBarangFormCek,
        projectQCBarangFormCek: constProjectQCBarangFormCek,

        projectNotaBarangFoto: constProjectNotaBarangFoto,
        projectMediaQC: constProjectMediaQC,

        projectNotaDPBiaya: constProjectNotaDPBiaya,
        projectNotaDPMetode: constProjectNotaDPMetode,

        projectNotaRekomendasiPengerjaan: constProjectNotaRekomendasiPengerjaan,
        projectNotaRekomendasiCatatan: constProjectNotaRekomendasiCatatan,

        projectNotaCatatan: constProjectNotaCatatan,
        projectNotaPriority: constProjectNotaProjectPriority,

        projectNotaDateLinePengecekan: constProjectNotaDateLinePengecekan,
        projectNotaDateLineSelesai: constProjectNotaDateLineSelesai,

        projectJenisService: {
            jenis: '',
            remind_in: ''
        },

        dataSelector: {
            barangCategory: [],
            barangFormCek: [],
            barangNamaSuggestion: [],
            teknisi: []
        },

        submitConfirmationModal: false,
        submitLoading: false,

        isEverSubmittedProgress: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const setDataProject = ({ stateData, stateDataBarangCategory, stateDataBarangFormCek, stateDataTeknisi, stateDataBarangNamaSuggestion, stateIsEverSubmittedProgress }) => {
        if (Array.isArray(stateData) && (stateData.length > 0)) {

            setData(d => ({
                ...d,
                projectDataFlag: true,

                isEverSubmittedProgress: stateIsEverSubmittedProgress,

                projectJenisService: {
                    ...d.projectJenisService,
                    jenis: safeValue(stateData[0].service_category, ''),
                    remind_in: safeValue(stateData[0].remind_in_month, ''),
                },

                projectCancelFrom: safeValue(stateData[0].cancel_from_process, ''),

                dataSelector: {
                    ...d.dataSelector,
                    barangCategory: stateDataBarangCategory,
                    barangFormCek: stateDataBarangFormCek,
                    barangNamaSuggestion: stateDataBarangNamaSuggestion,
                    teknisi: stateDataTeknisi
                },
                projectCustomer: {
                    ...d.projectCustomer,
                    value: {
                        ...d.projectCustomer.value,
                        id: safeValue(stateData[0].customer_id, ''),
                        name: safeValue(stateData[0].customer_name, '[Nama]'),
                        gender: safeValue(stateData[0].customer_gender, '1'),
                        address: safeValue(stateData[0].customer_address, '[Alamat]'),
                        contact: safeValue(stateData[0].customer_contact, '[Kontak]'),
                        categorySlug: safeValue(stateData[0].customer_category_slug, ''),
                        categoryName: safeValue(stateData[0].customer_category_name, ''),
                    }
                },
                projectNotaNomor: {
                    ...d.projectNotaNomor,
                    value: {
                        ...d.projectNotaNomor.value,
                        id: safeValue(stateData[0].project_id, ''),
                        userCreatedName: safeValue(stateData[0].project_created_user_name, ''),
                        userCreatedSubLevel: safeValue(stateData[0].project_created_user_sub_level, ''),
                        createdDateTime: stateData[0].project_created_datetime
                    }
                },
                projectNotaTanggalMasuk: {
                    ...d.projectNotaTanggalMasuk,
                    value: sqlDateToIsoDate(safeValue(stateData[0].tanggal_nota, ''), new Date())
                },
                projectNotaBarangCategory: {
                    ...d.projectNotaBarangCategory,
                    value: {
                        ...d.projectNotaBarangCategory.value,
                        id: safeValue(stateData[0].barang_category_id, '')
                    }
                },
                projectNotaBarangNama: {
                    ...d.projectNotaBarangNama,
                    value: safeValue(stateData[0].barang_nama, '')
                },
                projectNotaBarangKeluhan: {
                    ...d.projectNotaBarangKeluhan,
                    value: safeValue(stateData[0].barang_keluhan, '')
                },
                projectNotaBarangKelengkapan: {
                    ...d.projectNotaBarangKelengkapan,
                    value: stateData[0].barang_kelengkapan
                },
                projectNotaBarangFormCek: {
                    ...d.projectNotaBarangFormCek,
                    value: {
                        ...d.projectNotaBarangFormCek.value,
                        masterId: safeValue(stateData[0].barang_form_cek_id, ''),
                        detil: stateData[0].barang_form_cek_detil,
                    }
                },
                projectQCBarangFormCek: {
                    ...d.projectQCBarangFormCek,
                    value: {
                        ...d.projectQCBarangFormCek.value,
                        masterId: safeValue(stateData[0].barang_form_cek_id, ''),
                        detil: stateData[0].barang_form_cek_detil,
                    }
                },
                projectNotaBarangFoto: {
                    ...d.projectNotaBarangFoto,
                    value: stateData[0].barang_foto_nota
                },

                projectMediaQC: {
                    ...d.projectMediaQC,
                    value: stateData[0].qc_media
                },

                projectNotaDPBiaya: {
                    ...d.projectNotaDPBiaya,
                    value: Number(stateData[0].biaya_dp) === 0 ? '' : stateData[0].biaya_dp
                },
                projectNotaDPMetode: {
                    ...d.projectNotaDPMetode,
                    value: safeValue(stateData[0].biaya_dp_metode, '')
                },
                projectNotaRekomendasiPengerjaan: {
                    ...d.projectNotaRekomendasiPengerjaan,
                    value: {
                        ...d.projectNotaRekomendasiPengerjaan.value,
                        id: safeValue(stateData[0].recommendation_penerima_user_id, ''),
                        name: safeValue(stateData[0].penerima_rekomendasi_nama, ''),
                        gender: safeValue(stateData[0].penerima_rekomendasi_gender, ''),
                        level: safeValue(stateData[0].penerima_rekomendasi_level, ''),
                        subLevel: safeValue(stateData[0].penerima_rekomendasi_sub_level, ''),
                    }
                },
                projectNotaRekomendasiCatatan: {
                    ...d.projectNotaRekomendasiCatatan,
                    value: safeValue(stateData[0].recommendation_info, '')
                },
                projectNotaCatatan: {
                    ...d.projectNotaCatatan,
                    value: safeValue(stateData[0].catatan_nota, '')
                },
                projectNotaPriority: {
                    ...d.projectNotaPriority,
                    value: safeValue(stateData[0].project_priority, '')
                },
                projectNotaDateLinePengecekan: {
                    ...d.projectNotaDateLinePengecekan,
                    value: stateData[0].date_line_pengecekan ? sqlDateToIsoDate(stateData[0].date_line_pengecekan, null) : null,

                    today: stateData[0].today ? stateData[0].today : null,
                    hasPengecekan: stateData[0].has_pengecekan ? stateData[0].has_pengecekan : null,
                    dateLine: stateData[0].date_line_pengecekan ? stateData[0].date_line_pengecekan : null,
                },
                projectNotaDateLineSelesai: {
                    ...d.projectNotaDateLineSelesai,
                    value: stateData[0].date_line_selesai ? sqlDateToIsoDate(stateData[0].date_line_selesai, null) : null,
                    today: stateData[0].today ? stateData[0].today : null,
                    dateLine: stateData[0].date_line_selesai ? stateData[0].date_line_selesai : null,
                    tanggalSelesai: stateData[0].tanggal_selesai ? stateData[0].tanggal_selesai : null,
                },
            }))
        }
    }

    React.useEffect(() => {
        if (stateURI1) {

            setData(d => ({
                ...d,
                projectDataInitLoading: true,

                projectCustomer: { ...d.projectCustomer, error: '' },
                projectNotaNomor: { ...d.projectNotaNomor, error: '' },
                projectNotaTanggalMasuk: { ...d.projectNotaTanggalMasuk, error: '' },
                projectNotaBarangCategory: { ...d.projectNotaBarangCategory, error: '' },
                projectNotaBarangNama: { ...d.projectNotaBarangNama, error: '' },
                projectNotaBarangKeluhan: { ...d.projectNotaBarangKeluhan, error: '' },
                projectNotaBarangFoto: { ...d.projectNotaBarangFoto, error: '' },
                projectMediaQC: { ...d.projectMediaQC, error: '' },
                projectNotaPriority: { ...d.projectNotaPriority, error: '' },
                projectNotaDPMetode: { ...d.projectNotaDPMetode, error: '' },
            }))

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('flag_all', utils.flagAll);
            formDT.append('project_id', stateURI1);
            formDT.append('project_process', stateUtilsRef.projectProcess);
            formDT.append('project_is_cancel', stateUtilsRef.projectIsCancel);
            formDT.append('project_process_sudah_diambil', utils.projectProcess.sudah_diambil.value);
            formDT.append('project_progress_submitted_flag', utils.pengerjaanProgress.disubmit.value);

            axios({
                method: 'post',
                url: BE_API_TWO + '/select_project_by_project_id__project_antrian',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, projectDataInitLoading: false }));

                if (response.data.flag_status === 'isset') {
                    setDataProject({
                        stateData: response.data.data_project,
                        stateDataBarangCategory: response.data.data_barang_category,
                        stateDataBarangFormCek: response.data.data_barang_form_cek,
                        stateDataTeknisi: response.data.data_teknisi,
                        stateDataBarangNamaSuggestion: response.data.data_barang_name_suggestion,
                        stateIsEverSubmittedProgress: response.data.data_isset_submitted_progress
                    });
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorGetDataProject,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        projectDataFlag: false
                    }));
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    projectDataInitLoading: false
                }))

                notifications.show({
                    id: notificationId.current.errorGetDataProject,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }, [handleSetLoginContext, loginContext, loginContext.syswebapp, stateURI1, stateUtilsRef.projectProcess, stateUtilsRef.projectIsCancel])

    return (
        <React.Fragment>
            {data.projectDataInitLoading &&
                <PaperWrapper>
                    <Text size='sm' color="dimmed">Loading Data Nota..</Text>
                </PaperWrapper>
            }

            {!data.projectDataInitLoading && (data.projectDataFlag === false) &&
                <Text color="dimmed" align="center" py='2rem'>No Data</Text>
            }

            {!data.projectDataInitLoading && (data.projectDataFlag === true) &&
                <Box>
                    <Box mb='1rem'>
                        <PaperWrapper>
                            <Group align='flex-start'>
                                <Avatar
                                    radius="xl"
                                >
                                    <CustomerCategoryIcon
                                        stateCustomerCategory={data.projectCustomer.value.categorySlug}
                                        stateSize='1.5rem'
                                        stateColor={theme.colorScheme === 'light' ? '#000' : '#fff'}
                                    />
                                </Avatar>

                                <Box>
                                    <Text size="sm" fw={500}>
                                        {data.projectCustomer.value.name}
                                    </Text>

                                    <Text size="xs">
                                        {data.projectCustomer.value.categoryName}
                                    </Text>

                                    <Text size="xs">
                                        {data.projectCustomer.value.address}
                                    </Text>

                                    {canAccessSeeCustomersPhoneNumber({ stateObject: { subLevel: loginContext } }) &&
                                        <Text size="xs">
                                            {data.projectCustomer.value.contact}
                                        </Text>
                                    }
                                </Box>
                            </Group>
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            <NomorNotaDibatalkan
                                stateData={{
                                    data: data.projectNotaNomor
                                }}
                            />
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            <Box mb='1rem'>
                                <BarangCategoryDibatalkan
                                    stateData={{
                                        data: data.projectNotaBarangCategory,
                                        dataBarangCategory: data.dataSelector.barangCategory
                                    }}
                                />
                            </Box>

                            <Box mb='1rem'>
                                <BarangNamaDibatalkan
                                    stateData={{
                                        data: data.projectNotaBarangNama,
                                    }}
                                />
                            </Box>

                            <BarangKeluhanDibatalkan
                                stateData={{
                                    data: data.projectNotaBarangKeluhan,
                                }}
                            />
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            <BarangKelengkapanDibatalkan
                                stateData={{
                                    data: data.projectNotaBarangKelengkapan,
                                }}
                            />
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            {canAccessSeeModulQC({ stateObject: { subLevel: loginContext } }) ?
                                <React.Fragment>
                                    {[utils.projectProcess.qc.value, utils.projectProcess.selesai.value, utils.projectProcess.sudah_diambil.value].includes(stateUtilsRef.projectProcess) ?
                                        <React.Fragment>
                                            <BarangFormCekQC
                                                stateData={{
                                                    projectId: data.projectNotaNomor.value.id,
                                                    projectProcess: stateUtilsRef.projectProcess,
                                                    projectIsCancel: stateUtilsRef.projectIsCancel,
                                                    userAccess: stateUtilsRef.userAccess,

                                                    data: data.projectNotaBarangFormCek,
                                                    dataBarangFormCek: data.dataSelector.barangFormCek
                                                }}

                                                fnOnChangeMaster={() => { }}

                                                fnOnChangeDetil={(arrayDetil) => {
                                                    setData(d => ({
                                                        ...d,
                                                        projectNotaBarangFormCek: {
                                                            ...d.projectNotaBarangFormCek,
                                                            value: {
                                                                ...d.projectNotaBarangFormCek.value,
                                                                detil: arrayDetil
                                                            }
                                                        }
                                                    }))
                                                    // fnRefreshNotaIndex();
                                                }}
                                            />

                                            {/* media foto video */}
                                        </React.Fragment>
                                        :
                                        <BarangFormCek
                                            stateData={{
                                                projectId: data.projectNotaNomor.value.id,
                                                projectProcess: stateUtilsRef.projectProcess,
                                                projectIsCancel: stateUtilsRef.projectIsCancel,
                                                userAccess: stateUtilsRef.userAccess,

                                                data: data.projectNotaBarangFormCek,
                                                dataBarangFormCek: data.dataSelector.barangFormCek
                                            }}

                                            fnOnChangeMaster={(valMaster, valDetil) => {
                                                setData(d => ({
                                                    ...d,
                                                    projectNotaBarangFormCek: {
                                                        ...d.projectNotaBarangFormCek,
                                                        value: {
                                                            ...d.projectNotaBarangFormCek.value,
                                                            masterId: valMaster,
                                                            detil: valDetil
                                                        }
                                                    }
                                                }))
                                                // fnRefreshNotaIndex();
                                            }}

                                            fnUpdateDetil={(val) => {
                                                setData(d => ({
                                                    ...d,
                                                    projectNotaBarangFormCek: {
                                                        ...d.projectNotaBarangFormCek,
                                                        value: {
                                                            ...d.projectNotaBarangFormCek.value,
                                                            detil: val
                                                        }
                                                    }
                                                }))
                                            }}

                                            fnOnChangeDetil={(arrayDetil) => {
                                                setData(d => ({
                                                    ...d,
                                                    projectNotaBarangFormCek: {
                                                        ...d.projectNotaBarangFormCek,
                                                        value: {
                                                            ...d.projectNotaBarangFormCek.value,
                                                            detil: arrayDetil
                                                        }
                                                    }
                                                }))
                                                // fnRefreshNotaIndex();
                                            }}
                                        />
                                    }

                                    {(stateShowMediaQC === true) && data.isEverSubmittedProgress &&
                                        <MediaImageVideoCarousel
                                            stateMT='2.5rem'
                                            stateData={{
                                                projectId: data.projectNotaNomor.value.id,
                                                projectProcess: stateUtilsRef.projectProcess,
                                                projectIsCancel: stateUtilsRef.projectIsCancel,
                                                userAccess: stateUtilsRef.userAccess,

                                                data: data.projectMediaQC,
                                            }}

                                            fnOnChange={(array) => {
                                                setData(d => ({
                                                    ...d,
                                                    projectMediaQC: {
                                                        ...d.projectMediaQC,
                                                        value: array
                                                    }
                                                }))
                                                // fnRefreshNotaIndex();
                                            }}

                                            fnClickMedia={(object) => fnClickMediaImageVideo(object)}
                                        />
                                    }
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    {[utils.projectProcess.qc.value, utils.projectProcess.selesai.value, utils.projectProcess.sudah_diambil.value].includes(data.projectCancelFrom) ?
                                        <React.Fragment>
                                            <BarangFormCekQCDibatalkan
                                                stateData={{
                                                    data: data.projectNotaBarangFormCek,
                                                    dataBarangFormCek: data.dataSelector.barangFormCek
                                                }}
                                            />

                                            {/* media foto video */}
                                        </React.Fragment>
                                        :
                                        <BarangFormCekDibatalkan
                                            stateData={{
                                                data: data.projectNotaBarangFormCek,
                                                dataBarangFormCek: data.dataSelector.barangFormCek
                                            }}
                                        />
                                    }

                                    {stateShowMediaQC === true && data.isEverSubmittedProgress &&
                                        <MediaImageVideoCarouselDibatalkan
                                            stateMT='2.5rem'
                                            stateData={{
                                                projectId: data.projectNotaNomor.value.id,
                                                projectProcess: stateUtilsRef.projectProcess,
                                                projectIsCancel: stateUtilsRef.projectIsCancel,
                                                userAccess: stateUtilsRef.userAccess,

                                                data: data.projectMediaQC,
                                            }}

                                            fnClickMedia={(object) => fnClickMediaImageVideo(object)}
                                        />
                                    }
                                </React.Fragment>
                            }
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            <BarangProjectNotaFotoDibatalkan
                                stateData={{
                                    projectId: data.projectNotaNomor.value.id,
                                    projectProcess: stateUtilsRef.projectProcess,
                                    projectIsCancel: stateUtilsRef.projectIsCancel,
                                    userAccess: stateUtilsRef.userAccess,

                                    data: data.projectNotaBarangFoto,
                                }}

                                fnClickPhoto={(object) => fnClickPhoto({
                                    images: object.images,
                                    title: object.title,
                                    index: object.index,
                                    fieldName: object.fieldName,
                                })}
                            />
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            <BarangDPBiayaDibatalkan
                                stateData={{
                                    data: data.projectNotaDPBiaya,
                                }}
                            />

                            {Number(data.projectNotaDPBiaya.value) !== 0 &&
                                <Box mt='1rem'>
                                    <BarangDPBiayaMetodeDibatalkan
                                        stateData={{
                                            data: data.projectNotaDPMetode,
                                        }}
                                    />
                                </Box>
                            }
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            <RekomendasiPenerimaDibatalkan
                                stateData={{
                                    data: data.projectNotaRekomendasiPengerjaan,
                                }}
                            />

                            {data.projectNotaRekomendasiPengerjaan.value.id &&
                                <Box mt='1rem'>
                                    <RekomendasiPenerimaInfoDibatalkan
                                        stateData={{
                                            data: data.projectNotaRekomendasiCatatan,
                                        }}
                                    />
                                </Box>
                            }
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            <Box mb='1.5rem'>
                                <TanggalMasukProjectDibatalkan
                                    stateData={{
                                        data: data.projectNotaTanggalMasuk,
                                    }}
                                />
                            </Box>

                            <Box mb='1rem'>
                                <DateLinePengecekanDibatalkan
                                    stateData={{
                                        data: data.projectNotaDateLinePengecekan,
                                    }}
                                />
                            </Box>

                            <Box mb='1.5rem'>
                                <DateLineSelesaiDibatalkan
                                    stateData={{
                                        data: data.projectNotaDateLineSelesai,
                                    }}
                                />
                            </Box>

                            <Box mb='1.5rem'>
                                <PriorityNotaDibatalkan
                                    stateData={{
                                        data: data.projectNotaPriority,
                                    }}
                                />
                            </Box>

                            <JenisService
                                stateData={{
                                    data: data.projectJenisService,
                                }}
                            />
                        </PaperWrapper>
                    </Box>

                    <Box mb='1rem'>
                        <PaperWrapper>
                            <ProjectNotaCatatanDibatalkan
                                stateData={{
                                    data: data.projectNotaCatatan,
                                }}
                            />
                        </PaperWrapper>
                    </Box>

                    {canAccessTandaTerima({ stateObject: { subLevel: loginContext } }) && stepsCanAccessTandaTerima({ stateActualStep: stateUtilsRef.projectProcess }) &&
                        <Box mb='xs'>
                            <PaperWrapper>
                                <Text
                                    size='sm'
                                    fw='bold'
                                >
                                    Tanda Terima
                                </Text>

                                <Divider my='sm' />

                                <TandaTerimaComponent
                                    stateDT={{
                                        projectId: data.projectNotaNomor.value.id,
                                        projectStep: stateUtilsRef.projectProcess,
                                        projectIsCancel: stateUtilsRef.projectIsCancel,
                                        caption: 'TANDA TERIMA'
                                    }}
                                />
                            </PaperWrapper>
                        </Box>
                    }

                    {canAccessInvoiceDanBuktiBayar({ stateObject: { subLevel: loginContext } }) && stepsCanAccessInvoice({ stateActualStep: stateUtilsRef.projectProcess }) &&
                        <Box mb='xs'>
                            <PaperWrapper>
                                <Text
                                    size='sm'
                                    fw='bold'
                                >
                                    Invoice
                                </Text>

                                <Divider my='sm' />

                                <INVBBComponent
                                    stateDT={{
                                        projectId: data.projectNotaNomor.value.id,
                                        projectStep: stateUtilsRef.projectProcess,
                                        projectIsCancel: stateUtilsRef.projectIsCancel,
                                        caption: 'INVOICE',
                                        jenisDokumen: utils.jenisDokumen.invoice.value,
                                    }}
                                />
                            </PaperWrapper>
                        </Box>
                    }

                    {canAccessInvoiceDanBuktiBayar({ stateObject: { subLevel: loginContext } }) && stepsCanAccessBuktiBayar({ stateActualStep: stateUtilsRef.projectProcess }) &&
                        <Box>
                            <PaperWrapper>
                                <Text
                                    size='sm'
                                    fw='bold'
                                >
                                    Bukti Pembayaran
                                </Text>

                                <Divider my='sm' />

                                <INVBBComponent
                                    stateDT={{
                                        projectId: data.projectNotaNomor.value.id,
                                        projectStep: stateUtilsRef.projectProcess,
                                        projectIsCancel: stateUtilsRef.projectIsCancel,
                                        caption: 'BUKTI PEMBAYARAN',
                                        jenisDokumen: utils.jenisDokumen.buktiBayar.value,
                                    }}
                                />
                            </PaperWrapper>
                        </Box>
                    }
                </Box>
            }

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default React.memo(StepNotaDibatalkan);